import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../../response.js';
import { acceptJson, authHeader } from '../../shared.js';
import { prescriptionsListSpec } from './specs.js';

function list(apiUrl, accessToken, request) {
    return _list.apply(this, arguments);
}
function _list() {
    _list = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, request) {
        return validateResponse(prescriptionsListSpec, (yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(request.customerId)}/prescriptions`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, authHeader(accessToken))
        })));
    });
    return _list.apply(this, arguments);
}

export { list };
//# sourceMappingURL=list.js.map
